function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _filter, _filter2, _filter3, _filter4, _filter5, _filter6, _filter7, _filter8, _filter9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPotentialAnalysisModal(_ref, svgRef) {
  var _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132, _ref133;
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 627,
    height: 120,
    viewBox: "0 0 627 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_27344_71754)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27344_71754)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 626,
    height: 120,
    rx: 12,
    fill: "url(#paint0_radial_27344_71754)",
    style: {}
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.5,
    y: 9.41016,
    width: 100,
    height: 100,
    rx: 18,
    fill: "#F3F3F4",
    style: (_ref2 = {
      fill: "#F3F3F4"
    }, _defineProperty(_ref2, "fill", "color(display-p3 0.9529 0.9529 0.9569)"), _defineProperty(_ref2, "fillOpacity", 1), _ref2)
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_27344_71754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M455.5 59.4102C460.471 59.4102 464.592 63.4807 463.583 68.3476C462.608 73.0462 460.867 77.5737 458.411 81.7431C454.424 88.5105 448.699 94.0874 441.829 97.8948C434.959 101.702 427.196 103.601 419.344 103.395C411.492 103.189 403.839 100.884 397.179 96.7212C390.518 92.5582 385.094 86.6882 381.468 79.7207C377.843 72.7533 376.148 64.9423 376.561 57.0988C376.973 49.2553 379.478 41.6652 383.815 35.1166C386.486 31.082 389.793 27.5334 393.59 24.5986C397.522 21.5586 402.987 23.4803 405.165 27.9484L418.035 54.3534C419.543 57.4472 422.684 59.4102 426.125 59.4102H455.5Z",
    fill: "#52EAAF",
    style: (_ref3 = {
      fill: "#52EAAF"
    }, _defineProperty(_ref3, "fill", "color(display-p3 0.3216 0.9176 0.6863)"), _defineProperty(_ref3, "fillOpacity", 1), _ref3)
  })), /*#__PURE__*/React.createElement("path", {
    d: "M400.164 82.0906C400.821 82.0906 401.45 81.8299 401.915 81.3657C402.379 80.9016 402.639 80.272 402.639 79.6156C402.639 78.9592 402.379 78.3297 401.915 77.8655C401.45 77.4014 400.821 77.1406 400.164 77.1406C399.508 77.1406 398.879 77.4014 398.414 77.8655C397.95 78.3297 397.689 78.9592 397.689 79.6156C397.689 80.272 397.95 80.9016 398.414 81.3657C398.879 81.8299 399.508 82.0906 400.164 82.0906Z",
    stroke: "#101820",
    style: (_ref4 = {
      stroke: "#101820"
    }, _defineProperty(_ref4, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref4, "strokeOpacity", 1), _ref4),
    strokeWidth: 0.733333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.998 77.7829L406.398 74.8496",
    stroke: "#101820",
    style: (_ref5 = {
      stroke: "#101820"
    }, _defineProperty(_ref5, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref5, "strokeOpacity", 1), _ref5),
    strokeWidth: 0.733333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.073 40.9324C400.398 40.9324 400.72 40.8684 401.02 40.744C401.32 40.6196 401.593 40.4373 401.823 40.2075C402.053 39.9777 402.235 39.7048 402.359 39.4046C402.484 39.1043 402.548 38.7824 402.548 38.4574C402.548 38.1324 402.484 37.8106 402.359 37.5103C402.235 37.21 402.053 36.9372 401.823 36.7073C401.593 36.4775 401.32 36.2952 401.02 36.1708C400.72 36.0464 400.398 35.9824 400.073 35.9824C399.416 35.9824 398.787 36.2432 398.323 36.7073C397.858 37.1715 397.598 37.801 397.598 38.4574C397.598 39.1138 397.858 39.7434 398.323 40.2075C398.787 40.6717 399.416 40.9324 400.073 40.9324Z",
    stroke: "#101820",
    style: (_ref6 = {
      stroke: "#101820"
    }, _defineProperty(_ref6, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref6, "strokeOpacity", 1), _ref6),
    strokeWidth: 0.733333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.998 40.3828L406.398 43.3161",
    stroke: "#101820",
    style: (_ref7 = {
      stroke: "#101820"
    }, _defineProperty(_ref7, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref7, "strokeOpacity", 1), _ref7),
    strokeWidth: 0.733333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.325 82.0887C441.981 82.0887 442.611 81.8279 443.075 81.3638C443.539 80.8996 443.8 80.2701 443.8 79.6137C443.8 78.9573 443.539 78.3277 443.075 77.8636C442.611 77.3994 441.981 77.1387 441.325 77.1387C440.668 77.1387 440.039 77.3994 439.575 77.8636C439.11 78.3277 438.85 78.9573 438.85 79.6137C438.85 80.2701 439.11 80.8996 439.575 81.3638C440.039 81.8279 440.668 82.0887 441.325 82.0887Z",
    stroke: "#101820",
    style: (_ref8 = {
      stroke: "#101820"
    }, _defineProperty(_ref8, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref8, "strokeOpacity", 1), _ref8),
    strokeWidth: 0.733333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.4 77.781L435 74.8477",
    stroke: "#101820",
    style: (_ref9 = {
      stroke: "#101820"
    }, _defineProperty(_ref9, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref9, "strokeOpacity", 1), _ref9),
    strokeWidth: 0.733333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.325 40.9324C441.65 40.9324 441.971 40.8684 442.272 40.744C442.572 40.6196 442.845 40.4373 443.075 40.2075C443.305 39.9777 443.487 39.7048 443.611 39.4046C443.736 39.1043 443.8 38.7824 443.8 38.4574C443.8 38.1324 443.736 37.8106 443.611 37.5103C443.487 37.21 443.305 36.9372 443.075 36.7073C442.845 36.4775 442.572 36.2952 442.272 36.1708C441.971 36.0464 441.65 35.9824 441.325 35.9824C440.668 35.9824 440.039 36.2432 439.575 36.7073C439.11 37.1715 438.85 37.801 438.85 38.4574C438.85 39.1138 439.11 39.7434 439.575 40.2075C440.039 40.6717 440.668 40.9324 441.325 40.9324Z",
    stroke: "#101820",
    style: (_ref10 = {
      stroke: "#101820"
    }, _defineProperty(_ref10, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref10, "strokeOpacity", 1), _ref10),
    strokeWidth: 0.733333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.4 40.3828L435 43.3161",
    stroke: "#101820",
    style: (_ref11 = {
      stroke: "#101820"
    }, _defineProperty(_ref11, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref11, "strokeOpacity", 1), _ref11),
    strokeWidth: 0.733333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_27344_71754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.113 91.127H424.603",
    stroke: "#101820",
    style: (_ref12 = {
      stroke: "#101820"
    }, _defineProperty(_ref12, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref12, "strokeOpacity", 1), _ref12),
    strokeWidth: 0.733333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.857 90.3828V91.8726",
    stroke: "#101820",
    style: (_ref13 = {
      stroke: "#101820"
    }, _defineProperty(_ref13, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref13, "strokeOpacity", 1), _ref13),
    strokeWidth: 0.733333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.545 83.3047H416.78",
    stroke: "#101820",
    style: (_ref14 = {
      stroke: "#101820"
    }, _defineProperty(_ref14, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref14, "strokeOpacity", 1), _ref14),
    strokeWidth: 0.733333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.662 82.1875V84.4222",
    stroke: "#101820",
    style: (_ref15 = {
      stroke: "#101820"
    }, _defineProperty(_ref15, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref15, "strokeOpacity", 1), _ref15),
    strokeWidth: 0.733333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.24 84.3291C421.24 84.6531 421.369 84.9638 421.598 85.1929C421.827 85.422 422.138 85.5507 422.462 85.5507C422.786 85.5507 423.097 85.422 423.326 85.1929C423.555 84.9638 423.684 84.6531 423.684 84.3291C423.684 84.0051 423.555 83.6943 423.326 83.4652C423.097 83.2361 422.786 83.1074 422.462 83.1074C422.138 83.1074 421.827 83.2361 421.598 83.4652C421.369 83.6943 421.24 84.0051 421.24 84.3291Z",
    stroke: "#101820",
    style: (_ref16 = {
      stroke: "#101820"
    }, _defineProperty(_ref16, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref16, "strokeOpacity", 1), _ref16),
    strokeWidth: 0.733333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.565 85.7852L414.847 90.5029C414.656 90.6939 414.549 90.9529 414.549 91.223C414.549 91.4931 414.656 91.7521 414.847 91.9431C415.038 92.1341 415.297 92.2413 415.567 92.2413C415.837 92.2413 416.096 92.1341 416.287 91.9431L417.005 91.225L417.729 91.949C417.882 92.1018 418.089 92.1877 418.305 92.1877C418.521 92.1877 418.728 92.1018 418.881 91.949C419.034 91.7963 419.12 91.589 419.12 91.373C419.12 91.1569 419.034 90.9497 418.881 90.7969L418.157 90.0729L421.005 87.2254C421.697 87.5745 422.49 87.6658 423.243 87.4829C423.996 87.2999 424.659 86.8547 425.113 86.227C425.567 85.5994 425.783 84.8305 425.721 84.0582C425.66 83.2859 425.325 82.5607 424.777 82.0129C424.229 81.4651 423.504 81.1304 422.732 81.0689C421.96 81.0074 421.191 81.2231 420.563 81.6773C419.936 82.1315 419.49 82.7945 419.307 83.5474C419.124 84.3002 419.216 85.0936 419.565 85.7852Z",
    stroke: "#101820",
    style: (_ref17 = {
      stroke: "#101820"
    }, _defineProperty(_ref17, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref17, "strokeOpacity", 1), _ref17),
    strokeWidth: 0.733333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_27344_71754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.268 54.999C388.268 55.4929 388.464 55.9666 388.813 56.3158C389.162 56.665 389.636 56.8612 390.13 56.8612C390.624 56.8612 391.097 56.665 391.447 56.3158C391.796 55.9666 391.992 55.4929 391.992 54.999C391.992 54.5051 391.796 54.0314 391.447 53.6822C391.097 53.3329 390.624 53.1367 390.13 53.1367C389.636 53.1367 389.162 53.3329 388.813 53.6822C388.464 54.0314 388.268 54.5051 388.268 54.999Z",
    stroke: "#101820",
    style: (_ref18 = {
      stroke: "#101820"
    }, _defineProperty(_ref18, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref18, "strokeOpacity", 1), _ref18),
    strokeWidth: 0.733333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.449 61.7024C388.375 59.9817 386.406 56.4936 386.406 54.9983C386.406 54.1081 386.724 53.247 387.304 52.5713C387.883 51.8955 388.686 51.4497 389.566 51.3146C390.446 51.1795 391.345 51.3641 392.1 51.8349C392.856 52.3057 393.418 53.0315 393.684 53.881",
    stroke: "#101820",
    style: (_ref19 = {
      stroke: "#101820"
    }, _defineProperty(_ref19, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref19, "strokeOpacity", 1), _ref19),
    strokeWidth: 0.733333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.869 58.3516H394.725C394.791 58.3516 394.854 58.3777 394.9 58.4243C394.947 58.4709 394.973 58.534 394.973 58.5999V62.4485H391.621V58.5999C391.621 58.534 391.647 58.4709 391.694 58.4243C391.74 58.3777 391.804 58.3516 391.869 58.3516Z",
    stroke: "#101820",
    style: (_ref20 = {
      stroke: "#101820"
    }, _defineProperty(_ref20, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref20, "strokeOpacity", 1), _ref20),
    strokeWidth: 0.733333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.972 62.4477H397.579V55.7435C397.579 55.6448 397.54 55.55 397.47 55.4802C397.4 55.4103 397.306 55.3711 397.207 55.3711H393.855C393.756 55.3711 393.661 55.4103 393.592 55.4802C393.522 55.55 393.482 55.6448 393.482 55.7435V58.3507",
    stroke: "#101820",
    style: (_ref21 = {
      stroke: "#101820"
    }, _defineProperty(_ref21, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref21, "strokeOpacity", 1), _ref21),
    strokeWidth: 0.733333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.62 62.4473H390.875",
    stroke: "#101820",
    style: (_ref22 = {
      stroke: "#101820"
    }, _defineProperty(_ref22, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref22, "strokeOpacity", 1), _ref22),
    strokeWidth: 0.733333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.482 59.8418H394.972",
    stroke: "#101820",
    style: (_ref23 = {
      stroke: "#101820"
    }, _defineProperty(_ref23, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref23, "strokeOpacity", 1), _ref23),
    strokeWidth: 0.733333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.461 56.8613H397.578",
    stroke: "#101820",
    style: (_ref24 = {
      stroke: "#101820"
    }, _defineProperty(_ref24, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref24, "strokeOpacity", 1), _ref24),
    strokeWidth: 0.733333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.461 58.3516H397.578",
    stroke: "#101820",
    style: (_ref25 = {
      stroke: "#101820"
    }, _defineProperty(_ref25, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref25, "strokeOpacity", 1), _ref25),
    strokeWidth: 0.733333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_27344_71754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448.459 58.3505C448.459 58.7191 448.35 59.0793 448.145 59.3857C447.94 59.692 447.649 59.9307 447.308 60.0715C446.968 60.2123 446.593 60.2489 446.231 60.1766C445.87 60.1044 445.538 59.9265 445.278 59.6656C445.018 59.4047 444.841 59.0724 444.77 58.7108C444.698 58.3492 444.736 57.9746 444.878 57.6344C445.019 57.2942 445.259 57.0037 445.566 56.7997C445.873 56.5957 446.233 56.4873 446.602 56.4883",
    stroke: "#101820",
    style: (_ref26 = {
      stroke: "#101820"
    }, _defineProperty(_ref26, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref26, "strokeOpacity", 1), _ref26),
    strokeWidth: 0.733333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.19 57.3579C450.276 57.682 450.32 58.0158 450.32 58.3511C450.317 59.1348 450.065 59.8974 449.602 60.5295C449.139 61.1616 448.487 61.6307 447.741 61.8696C446.994 62.1085 446.192 62.1049 445.447 61.8593C444.703 61.6136 444.056 61.1386 443.598 60.5023C443.141 59.8661 442.896 59.1012 442.9 58.3175C442.904 57.5338 443.157 56.7716 443.621 56.14C444.085 55.5085 444.737 55.0401 445.484 54.8021C446.23 54.5641 447.033 54.5688 447.777 54.8153",
    stroke: "#101820",
    style: (_ref27 = {
      stroke: "#101820"
    }, _defineProperty(_ref27, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref27, "strokeOpacity", 1), _ref27),
    strokeWidth: 0.733333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.602 58.3508L449.988 54.959",
    stroke: "#101820",
    style: (_ref28 = {
      stroke: "#101820"
    }, _defineProperty(_ref28, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref28, "strokeOpacity", 1), _ref28),
    strokeWidth: 0.733333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.877 62.4464L444.158 61.1602",
    stroke: "#101820",
    style: (_ref29 = {
      stroke: "#101820"
    }, _defineProperty(_ref29, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref29, "strokeOpacity", 1), _ref29),
    strokeWidth: 0.733333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.322 62.4472L449.041 61.166",
    stroke: "#101820",
    style: (_ref30 = {
      stroke: "#101820"
    }, _defineProperty(_ref30, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref30, "strokeOpacity", 1), _ref30),
    strokeWidth: 0.733333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.094 54.9582C452.014 55.0416 451.915 55.1045 451.805 55.1417C451.695 55.1788 451.578 55.1891 451.463 55.1718L449.974 54.9582L449.765 53.4833C449.749 53.3692 449.76 53.253 449.796 53.1436C449.832 53.0342 449.893 52.9347 449.974 52.8526L451.568 51.2734L452.02 52.9321L453.673 53.379L452.094 54.9582Z",
    stroke: "#101820",
    style: (_ref31 = {
      stroke: "#101820"
    }, _defineProperty(_ref31, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref31, "strokeOpacity", 1), _ref31),
    strokeWidth: 0.733333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_27344_71754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M419.915 27.836C419.935 27.796 419.966 27.7624 420.004 27.739C420.042 27.7155 420.086 27.7031 420.131 27.7031C420.176 27.7031 420.22 27.7155 420.258 27.739C420.296 27.7624 420.327 27.796 420.348 27.836L420.85 28.8501C420.868 28.8849 420.893 28.915 420.925 28.9378C420.957 28.9605 420.993 28.9752 421.032 28.9807L422.16 29.1436C422.204 29.1497 422.245 29.1681 422.28 29.1966C422.314 29.2252 422.34 29.2627 422.354 29.305C422.368 29.347 422.369 29.3921 422.359 29.435C422.348 29.478 422.326 29.5171 422.294 29.5478L421.474 30.3424C421.447 30.369 421.426 30.402 421.414 30.4384C421.402 30.4749 421.399 30.5136 421.406 30.5514L421.599 31.6713C421.607 31.7151 421.601 31.7601 421.584 31.8012C421.567 31.8422 421.539 31.8776 421.503 31.9032C421.466 31.9293 421.423 31.9448 421.378 31.9478C421.333 31.9509 421.289 31.9415 421.249 31.9206L420.244 31.3952C420.209 31.3768 420.17 31.3672 420.131 31.3672C420.092 31.3672 420.053 31.3768 420.018 31.3952L419.013 31.9206C418.973 31.9415 418.929 31.9509 418.884 31.9478C418.839 31.9448 418.796 31.9293 418.759 31.9032C418.723 31.8776 418.695 31.8422 418.678 31.8012C418.661 31.7601 418.656 31.7151 418.663 31.6713L418.856 30.5514C418.863 30.5136 418.86 30.4749 418.848 30.4384C418.836 30.402 418.815 30.369 418.788 30.3424L417.968 29.5478C417.937 29.5171 417.914 29.478 417.903 29.435C417.893 29.3921 417.894 29.347 417.908 29.305C417.922 29.2627 417.948 29.2252 417.982 29.1966C418.017 29.1681 418.058 29.1497 418.102 29.1436L419.23 28.9807C419.269 28.9752 419.306 28.9605 419.337 28.9378C419.369 28.915 419.395 28.8849 419.412 28.8501L419.915 27.836Z",
    stroke: "#101820",
    style: (_ref32 = {
      stroke: "#101820"
    }, _defineProperty(_ref32, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref32, "strokeOpacity", 1), _ref32),
    strokeWidth: 0.733333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.601 30.0857C424.601 29.2401 424.361 28.4118 423.909 27.6972C423.457 26.9825 422.811 26.4108 422.047 26.0484C421.283 25.686 420.432 25.5478 419.592 25.6499C418.753 25.7519 417.959 26.09 417.304 26.6249C416.649 27.1598 416.16 27.8695 415.892 28.6717C415.624 29.4738 415.59 30.3355 415.792 31.1565C415.994 31.9776 416.426 32.7243 417.036 33.3101C417.646 33.8959 418.409 34.2966 419.238 34.4657L420.132 36.7898L421.025 34.4657C422.035 34.2597 422.942 33.7111 423.594 32.913C424.245 32.1148 424.601 31.116 424.601 30.0857Z",
    stroke: "#101820",
    style: (_ref33 = {
      stroke: "#101820"
    }, _defineProperty(_ref33, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref33, "strokeOpacity", 1), _ref33),
    strokeWidth: 0.733333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M412.334 53.9285C412.334 58.1811 415.781 61.6285 420.034 61.6285C424.287 61.6285 427.734 58.1811 427.734 53.9285C427.734 49.6759 424.287 46.2285 420.034 46.2285C415.781 46.2285 412.334 49.6759 412.334 53.9285Z",
    stroke: "#101820",
    style: (_ref34 = {
      stroke: "#101820"
    }, _defineProperty(_ref34, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref34, "strokeOpacity", 1), _ref34),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.334 53.9285C416.36 53.9093 419.662 50.5361 420.034 46.2285C416.008 46.2478 412.706 49.6209 412.334 53.9285Z",
    stroke: "#101820",
    style: (_ref35 = {
      stroke: "#101820"
    }, _defineProperty(_ref35, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref35, "strokeOpacity", 1), _ref35),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.733 53.9285C423.707 53.9093 420.405 50.5361 420.033 46.2285C424.059 46.2478 427.361 49.6209 427.733 53.9285Z",
    stroke: "#101820",
    style: (_ref36 = {
      stroke: "#101820"
    }, _defineProperty(_ref36, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref36, "strokeOpacity", 1), _ref36),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.928 60.9752C414.126 61.8112 411.935 63.7455 411.077 66.1677C410.612 67.4822 411.576 68.7181 412.957 68.9139C414.44 69.1251 416.727 69.328 420.034 69.328C423.341 69.328 425.628 69.1245 427.112 68.9139C428.492 68.7181 429.457 67.4822 428.991 66.1677C428.133 63.7455 425.942 61.8112 423.141 60.9757C422.162 61.4071 421.104 61.6291 420.034 61.6275C418.929 61.6275 417.878 61.3948 416.928 60.9752Z",
    stroke: "#101820",
    style: (_ref37 = {
      stroke: "#101820"
    }, _defineProperty(_ref37, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref37, "strokeOpacity", 1), _ref37),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.734 53.9285C427.734 58.1811 424.287 61.6285 420.034 61.6285C415.781 61.6285 412.334 58.1811 412.334 53.9285C412.334 49.6759 415.781 46.2285 420.034 46.2285C424.287 46.2285 427.734 49.6759 427.734 53.9285Z",
    stroke: "#101820",
    style: (_ref38 = {
      stroke: "#101820"
    }, _defineProperty(_ref38, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref38, "strokeOpacity", 1), _ref38),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.928 60.9766C414.126 61.812 411.935 63.7464 411.077 66.1686C410.612 67.4831 411.576 68.7189 412.957 68.9153C414.44 69.1254 416.726 69.3289 420.034 69.3289C423.342 69.3289 425.628 69.1254 427.112 68.9153C428.492 68.7189 429.457 67.4831 428.991 66.1686C428.133 63.7464 425.942 61.812 423.141 60.9766",
    stroke: "#101820",
    style: (_ref39 = {
      stroke: "#101820"
    }, _defineProperty(_ref39, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref39, "strokeOpacity", 1), _ref39),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.734 53.9285C423.481 53.9285 420.034 50.4811 420.034 46.2285C420.034 50.4811 416.587 53.9285 412.334 53.9285",
    stroke: "#101820",
    style: (_ref40 = {
      stroke: "#101820"
    }, _defineProperty(_ref40, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref40, "strokeOpacity", 1), _ref40),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.234 57.5039C421.271 58.9708 418.796 58.9708 417.834 57.5039",
    stroke: "#101820",
    style: (_ref41 = {
      stroke: "#101820"
    }, _defineProperty(_ref41, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref41, "strokeOpacity", 1), _ref41),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.283 54.4785V54.7535",
    stroke: "#101820",
    style: (_ref42 = {
      stroke: "#101820"
    }, _defineProperty(_ref42, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref42, "strokeOpacity", 1), _ref42),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.783 54.4785V54.7535",
    stroke: "#101820",
    style: (_ref43 = {
      stroke: "#101820"
    }, _defineProperty(_ref43, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref43, "strokeOpacity", 1), _ref43),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_27344_71754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M470 57.4102L652 52.9102",
    stroke: "#52EAAF",
    style: (_ref44 = {
      stroke: "#52EAAF"
    }, _defineProperty(_ref44, "stroke", "color(display-p3 0.3216 0.9176 0.6863)"), _defineProperty(_ref44, "strokeOpacity", 1), _ref44),
    strokeWidth: 0.911443
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_dd_27344_71754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.5 56.9111C370.5 56.9111 323 70.2437 240.5 32.9111C158 -4.42156 115 40.4111 115 40.4111",
    stroke: "#52EAAF",
    style: (_ref45 = {
      stroke: "#52EAAF"
    }, _defineProperty(_ref45, "stroke", "color(display-p3 0.3216 0.9176 0.6863)"), _defineProperty(_ref45, "strokeOpacity", 1), _ref45),
    strokeWidth: 0.911443
  })), /*#__PURE__*/React.createElement("rect", {
    x: 284.5,
    y: 25.4102,
    width: 46.4,
    height: 46.4,
    rx: 23.2,
    fill: "#F3F3F4",
    style: (_ref46 = {
      fill: "#F3F3F4"
    }, _defineProperty(_ref46, "fill", "color(display-p3 0.9529 0.9529 0.9569)"), _defineProperty(_ref46, "fillOpacity", 1), _ref46)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.002 44.7605C300.002 49.0131 303.449 52.4605 307.702 52.4605C311.955 52.4605 315.402 49.0131 315.402 44.7605C315.402 40.5079 311.955 37.0605 307.702 37.0605C303.449 37.0605 300.002 40.5079 300.002 44.7605Z",
    stroke: "#9FA3A6",
    style: (_ref47 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref47, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref47, "strokeOpacity", 1), _ref47),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.002 44.7605C304.028 44.7413 307.33 41.3681 307.702 37.0605C303.676 37.0798 300.374 40.4529 300.002 44.7605Z",
    stroke: "#9FA3A6",
    style: (_ref48 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref48, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref48, "strokeOpacity", 1), _ref48),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.401 44.7605C311.375 44.7413 308.073 41.3681 307.701 37.0605C311.727 37.0798 315.029 40.4529 315.401 44.7605Z",
    stroke: "#9FA3A6",
    style: (_ref49 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref49, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref49, "strokeOpacity", 1), _ref49),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.596 51.8072C301.794 52.6432 299.603 54.5775 298.745 56.9997C298.28 58.3142 299.244 59.5501 300.625 59.7459C302.108 59.9571 304.395 60.16 307.702 60.16C311.009 60.16 313.296 59.9565 314.779 59.7459C316.16 59.5501 317.125 58.3142 316.659 56.9997C315.801 54.5775 313.61 52.6432 310.808 51.8077C309.83 52.2391 308.772 52.4611 307.702 52.4595C306.597 52.4595 305.546 52.2268 304.596 51.8072Z",
    stroke: "#9FA3A6",
    style: (_ref50 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref50, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref50, "strokeOpacity", 1), _ref50),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.402 44.7605C315.402 49.0131 311.955 52.4605 307.702 52.4605C303.449 52.4605 300.002 49.0131 300.002 44.7605C300.002 40.5079 303.449 37.0605 307.702 37.0605C311.955 37.0605 315.402 40.5079 315.402 44.7605Z",
    stroke: "#9FA3A6",
    style: (_ref51 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref51, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref51, "strokeOpacity", 1), _ref51),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.596 51.8086C301.794 52.644 299.603 54.5784 298.745 57.0006C298.28 58.3151 299.244 59.5509 300.625 59.7473C302.108 59.9574 304.394 60.1609 307.702 60.1609C311.01 60.1609 313.296 59.9574 314.779 59.7473C316.16 59.5509 317.125 58.3151 316.659 57.0006C315.801 54.5784 313.61 52.644 310.808 51.8086",
    stroke: "#9FA3A6",
    style: (_ref52 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref52, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref52, "strokeOpacity", 1), _ref52),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.402 44.7605C311.149 44.7605 307.702 41.3131 307.702 37.0605C307.702 41.3131 304.255 44.7605 300.002 44.7605",
    stroke: "#9FA3A6",
    style: (_ref53 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref53, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref53, "strokeOpacity", 1), _ref53),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.902 48.3359C308.939 49.8028 306.464 49.8028 305.502 48.3359",
    stroke: "#9FA3A6",
    style: (_ref54 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref54, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref54, "strokeOpacity", 1), _ref54),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.951 45.3105V45.5855",
    stroke: "#9FA3A6",
    style: (_ref55 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref55, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref55, "strokeOpacity", 1), _ref55),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.451 45.3105V45.5855",
    stroke: "#9FA3A6",
    style: (_ref56 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref56, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref56, "strokeOpacity", 1), _ref56),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_27344_71754)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 335.5,
    y: 89.4102,
    width: 46.4,
    height: 46.4,
    rx: 23.2,
    fill: "#F3F3F4",
    style: (_ref57 = {
      fill: "#F3F3F4"
    }, _defineProperty(_ref57, "fill", "color(display-p3 0.9529 0.9529 0.9569)"), _defineProperty(_ref57, "fillOpacity", 1), _ref57)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.002 108.761C351.002 113.013 354.449 116.461 358.702 116.461C362.955 116.461 366.402 113.013 366.402 108.761C366.402 104.508 362.955 101.061 358.702 101.061C354.449 101.061 351.002 104.508 351.002 108.761Z",
    stroke: "#9FA3A6",
    style: (_ref58 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref58, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref58, "strokeOpacity", 1), _ref58),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.002 108.761C355.028 108.741 358.33 105.368 358.702 101.061C354.676 101.08 351.374 104.453 351.002 108.761Z",
    stroke: "#9FA3A6",
    style: (_ref59 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref59, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref59, "strokeOpacity", 1), _ref59),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.401 108.761C362.375 108.741 359.073 105.368 358.701 101.061C362.727 101.08 366.029 104.453 366.401 108.761Z",
    stroke: "#9FA3A6",
    style: (_ref60 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref60, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref60, "strokeOpacity", 1), _ref60),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.596 115.807C352.794 116.643 350.603 118.578 349.745 121C349.28 122.314 350.244 123.55 351.625 123.746C353.108 123.957 355.395 124.16 358.702 124.16C362.009 124.16 364.296 123.957 365.779 123.746C367.16 123.55 368.125 122.314 367.659 121C366.801 118.578 364.61 116.643 361.808 115.808C360.83 116.239 359.772 116.461 358.702 116.459C357.597 116.459 356.546 116.227 355.596 115.807Z",
    stroke: "#9FA3A6",
    style: (_ref61 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref61, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref61, "strokeOpacity", 1), _ref61),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.402 108.761C366.402 113.013 362.955 116.461 358.702 116.461C354.449 116.461 351.002 113.013 351.002 108.761C351.002 104.508 354.449 101.061 358.702 101.061C362.955 101.061 366.402 104.508 366.402 108.761Z",
    stroke: "#9FA3A6",
    style: (_ref62 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref62, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref62, "strokeOpacity", 1), _ref62),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.596 115.809C352.794 116.644 350.603 118.578 349.745 121.001C349.28 122.315 350.244 123.551 351.625 123.747C353.108 123.957 355.394 124.161 358.702 124.161C362.01 124.161 364.296 123.957 365.779 123.747C367.16 123.551 368.125 122.315 367.659 121.001C366.801 118.578 364.61 116.644 361.808 115.809",
    stroke: "#9FA3A6",
    style: (_ref63 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref63, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref63, "strokeOpacity", 1), _ref63),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.402 108.761C362.149 108.761 358.702 105.313 358.702 101.061C358.702 105.313 355.255 108.761 351.002 108.761",
    stroke: "#9FA3A6",
    style: (_ref64 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref64, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref64, "strokeOpacity", 1), _ref64),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.902 112.336C359.939 113.803 357.464 113.803 356.502 112.336",
    stroke: "#9FA3A6",
    style: (_ref65 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref65, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref65, "strokeOpacity", 1), _ref65),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.951 109.311V109.586",
    stroke: "#9FA3A6",
    style: (_ref66 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref66, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref66, "strokeOpacity", 1), _ref66),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.451 109.311V109.586",
    stroke: "#9FA3A6",
    style: (_ref67 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref67, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref67, "strokeOpacity", 1), _ref67),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 504.5,
    y: 87.4102,
    width: 46.4,
    height: 46.4,
    rx: 23.2,
    fill: "#F3F3F4",
    style: (_ref68 = {
      fill: "#F3F3F4"
    }, _defineProperty(_ref68, "fill", "color(display-p3 0.9529 0.9529 0.9569)"), _defineProperty(_ref68, "fillOpacity", 1), _ref68)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.002 106.761C520.002 111.013 523.449 114.461 527.702 114.461C531.955 114.461 535.402 111.013 535.402 106.761C535.402 102.508 531.955 99.0605 527.702 99.0605C523.449 99.0605 520.002 102.508 520.002 106.761Z",
    stroke: "#9FA3A6",
    style: (_ref69 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref69, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref69, "strokeOpacity", 1), _ref69),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.002 106.761C524.028 106.741 527.33 103.368 527.702 99.0605C523.676 99.0798 520.374 102.453 520.002 106.761Z",
    stroke: "#9FA3A6",
    style: (_ref70 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref70, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref70, "strokeOpacity", 1), _ref70),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.401 106.761C531.375 106.741 528.073 103.368 527.701 99.0605C531.727 99.0798 535.029 102.453 535.401 106.761Z",
    stroke: "#9FA3A6",
    style: (_ref71 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref71, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref71, "strokeOpacity", 1), _ref71),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.596 113.807C521.794 114.643 519.603 116.578 518.745 119C518.28 120.314 519.244 121.55 520.625 121.746C522.108 121.957 524.395 122.16 527.702 122.16C531.009 122.16 533.296 121.957 534.779 121.746C536.16 121.55 537.125 120.314 536.659 119C535.801 116.578 533.61 114.643 530.808 113.808C529.83 114.239 528.772 114.461 527.702 114.459C526.597 114.459 525.546 114.227 524.596 113.807Z",
    stroke: "#9FA3A6",
    style: (_ref72 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref72, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref72, "strokeOpacity", 1), _ref72),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.402 106.761C535.402 111.013 531.955 114.461 527.702 114.461C523.449 114.461 520.002 111.013 520.002 106.761C520.002 102.508 523.449 99.0605 527.702 99.0605C531.955 99.0605 535.402 102.508 535.402 106.761Z",
    stroke: "#9FA3A6",
    style: (_ref73 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref73, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref73, "strokeOpacity", 1), _ref73),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.596 113.809C521.794 114.644 519.603 116.578 518.745 119.001C518.28 120.315 519.244 121.551 520.625 121.747C522.108 121.957 524.394 122.161 527.702 122.161C531.01 122.161 533.296 121.957 534.779 121.747C536.16 121.551 537.125 120.315 536.659 119.001C535.801 116.578 533.61 114.644 530.808 113.809",
    stroke: "#9FA3A6",
    style: (_ref74 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref74, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref74, "strokeOpacity", 1), _ref74),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.402 106.761C531.149 106.761 527.702 103.313 527.702 99.0605C527.702 103.313 524.255 106.761 520.002 106.761",
    stroke: "#9FA3A6",
    style: (_ref75 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref75, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref75, "strokeOpacity", 1), _ref75),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.902 110.336C528.939 111.803 526.464 111.803 525.502 110.336",
    stroke: "#9FA3A6",
    style: (_ref76 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref76, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref76, "strokeOpacity", 1), _ref76),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.951 107.311V107.586",
    stroke: "#9FA3A6",
    style: (_ref77 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref77, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref77, "strokeOpacity", 1), _ref77),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.451 107.311V107.586",
    stroke: "#9FA3A6",
    style: (_ref78 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref78, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref78, "strokeOpacity", 1), _ref78),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_27344_71754)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 524.5,
    y: -45.5898,
    width: 86,
    height: 86,
    rx: 43,
    fill: "#F3F3F4",
    style: (_ref79 = {
      fill: "#F3F3F4"
    }, _defineProperty(_ref79, "fill", "color(display-p3 0.9529 0.9529 0.9569)"), _defineProperty(_ref79, "fillOpacity", 1), _ref79)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.232 -9.72454C553.232 -1.84257 559.622 4.54701 567.504 4.54701C575.386 4.54701 581.776 -1.84257 581.776 -9.72454C581.776 -17.6065 575.386 -23.9961 567.504 -23.9961C559.622 -23.9961 553.232 -17.6065 553.232 -9.72454Z",
    stroke: "#9FA3A6",
    style: (_ref80 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref80, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref80, "strokeOpacity", 1), _ref80),
    strokeWidth: 2.03879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.746 3.33696C556.554 4.88644 552.493 8.47166 550.903 12.9611C550.041 15.3974 551.828 17.688 554.386 18.0509C557.136 18.4424 561.374 18.8185 567.504 18.8185C573.634 18.8185 577.871 18.4414 580.621 18.0509C583.18 17.688 584.968 15.3974 584.105 12.9611C582.515 8.47166 578.454 4.88644 573.261 3.33798C571.447 4.13752 569.486 4.54898 567.504 4.54596C565.455 4.54596 563.508 4.11476 561.746 3.33696Z",
    stroke: "#9FA3A6",
    style: (_ref81 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref81, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref81, "strokeOpacity", 1), _ref81),
    strokeWidth: 2.03879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.776 -9.72454C581.776 -1.84257 575.386 4.54701 567.504 4.54701C559.622 4.54701 553.232 -1.84257 553.232 -9.72454C553.232 -17.6065 559.622 -23.9961 567.504 -23.9961C575.386 -23.9961 581.776 -17.6065 581.776 -9.72454Z",
    stroke: "#9FA3A6",
    style: (_ref82 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref82, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref82, "strokeOpacity", 1), _ref82),
    strokeWidth: 2.03879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.746 3.33789C556.554 4.88635 552.493 8.47157 550.903 12.961C550.041 15.3974 551.828 17.6879 554.386 18.0519C557.136 18.4413 561.373 18.8184 567.504 18.8184C573.635 18.8184 577.871 18.4413 580.621 18.0519C583.18 17.6879 584.968 15.3974 584.105 12.961C582.515 8.47157 578.454 4.88635 573.261 3.33789",
    stroke: "#9FA3A6",
    style: (_ref83 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref83, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref83, "strokeOpacity", 1), _ref83),
    strokeWidth: 2.03879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter6_f_27344_71754)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 345.9,
    y: -6.18945,
    width: 40.5996,
    height: 40.5996,
    rx: 20.2998,
    fill: "#F3F3F4",
    style: (_ref84 = {
      fill: "#F3F3F4"
    }, _defineProperty(_ref84, "fill", "color(display-p3 0.9529 0.9529 0.9569)"), _defineProperty(_ref84, "fillOpacity", 1), _ref84)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.465 10.7433C359.465 14.4643 362.481 17.4807 366.202 17.4807C369.923 17.4807 372.94 14.4643 372.94 10.7433C372.94 7.02231 369.923 4.00586 366.202 4.00586C362.481 4.00586 359.465 7.02231 359.465 10.7433Z",
    stroke: "#9FA3A6",
    style: (_ref85 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref85, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref85, "strokeOpacity", 1), _ref85),
    strokeWidth: 0.962491,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.465 10.7433C362.988 10.7265 365.877 7.77497 366.202 4.00586C362.68 4.0227 359.79 6.97418 359.465 10.7433Z",
    stroke: "#9FA3A6",
    style: (_ref86 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref86, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref86, "strokeOpacity", 1), _ref86),
    strokeWidth: 0.962491,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.941 10.7433C369.418 10.7265 366.528 7.77497 366.203 4.00586C369.726 4.0227 372.615 6.97418 372.941 10.7433Z",
    stroke: "#9FA3A6",
    style: (_ref87 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref87, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref87, "strokeOpacity", 1), _ref87),
    strokeWidth: 0.962491,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.486 16.9106C361.035 17.6421 359.118 19.3347 358.367 21.4541C357.96 22.6043 358.804 23.6856 360.012 23.8569C361.31 24.0417 363.311 24.2193 366.204 24.2193C369.098 24.2193 371.099 24.0413 372.397 23.8569C373.605 23.6856 374.449 22.6043 374.041 21.4541C373.291 19.3347 371.374 17.6421 368.922 16.9111C368.066 17.2886 367.14 17.4828 366.204 17.4814C365.237 17.4814 364.318 17.2778 363.486 16.9106Z",
    stroke: "#9FA3A6",
    style: (_ref88 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref88, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref88, "strokeOpacity", 1), _ref88),
    strokeWidth: 0.962491,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.94 10.7433C372.94 14.4643 369.923 17.4807 366.202 17.4807C362.481 17.4807 359.465 14.4643 359.465 10.7433C359.465 7.02231 362.481 4.00586 366.202 4.00586C369.923 4.00586 372.94 7.02231 372.94 10.7433Z",
    stroke: "#9FA3A6",
    style: (_ref89 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref89, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref89, "strokeOpacity", 1), _ref89),
    strokeWidth: 0.962491,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.486 16.9102C361.035 17.6412 359.118 19.3337 358.367 21.4531C357.96 22.6033 358.804 23.6846 360.012 23.8565C361.31 24.0403 363.31 24.2183 366.204 24.2183C369.099 24.2183 371.099 24.0403 372.397 23.8565C373.605 23.6846 374.449 22.6033 374.041 21.4531C373.291 19.3337 371.374 17.6412 368.922 16.9102",
    stroke: "#9FA3A6",
    style: (_ref90 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref90, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref90, "strokeOpacity", 1), _ref90),
    strokeWidth: 0.962491,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.94 10.7433C369.219 10.7433 366.202 7.72685 366.202 4.00586C366.202 7.72685 363.186 10.7433 359.465 10.7433",
    stroke: "#9FA3A6",
    style: (_ref91 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref91, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref91, "strokeOpacity", 1), _ref91),
    strokeWidth: 0.962491,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.129 13.8711C367.287 15.1546 365.121 15.1546 364.279 13.8711",
    stroke: "#9FA3A6",
    style: (_ref92 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref92, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref92, "strokeOpacity", 1), _ref92),
    strokeWidth: 0.962491,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.795 11.2227V11.4633",
    stroke: "#9FA3A6",
    style: (_ref93 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref93, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref93, "strokeOpacity", 1), _ref93),
    strokeWidth: 0.962491,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.609 11.2227V11.4633",
    stroke: "#9FA3A6",
    style: (_ref94 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref94, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref94, "strokeOpacity", 1), _ref94),
    strokeWidth: 0.962491,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 219.5,
    y: 59.4102,
    width: 46.4,
    height: 46.4,
    rx: 23.2,
    fill: "#F3F3F4",
    style: (_ref95 = {
      fill: "#F3F3F4"
    }, _defineProperty(_ref95, "fill", "color(display-p3 0.9529 0.9529 0.9569)"), _defineProperty(_ref95, "fillOpacity", 1), _ref95)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.002 78.7605C235.002 83.0131 238.449 86.4605 242.702 86.4605C246.955 86.4605 250.402 83.0131 250.402 78.7605C250.402 74.5079 246.955 71.0605 242.702 71.0605C238.449 71.0605 235.002 74.5079 235.002 78.7605Z",
    stroke: "#9FA3A6",
    style: (_ref96 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref96, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref96, "strokeOpacity", 1), _ref96),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.002 78.7605C239.028 78.7413 242.33 75.3681 242.702 71.0605C238.676 71.0798 235.374 74.4529 235.002 78.7605Z",
    stroke: "#9FA3A6",
    style: (_ref97 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref97, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref97, "strokeOpacity", 1), _ref97),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.401 78.7605C246.375 78.7413 243.073 75.3681 242.701 71.0605C246.727 71.0798 250.029 74.4529 250.401 78.7605Z",
    stroke: "#9FA3A6",
    style: (_ref98 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref98, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref98, "strokeOpacity", 1), _ref98),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.596 85.8072C236.794 86.6432 234.603 88.5775 233.745 90.9997C233.28 92.3142 234.244 93.5501 235.625 93.7459C237.108 93.9571 239.395 94.16 242.702 94.16C246.009 94.16 248.296 93.9565 249.779 93.7459C251.16 93.5501 252.125 92.3142 251.659 90.9997C250.801 88.5775 248.61 86.6432 245.808 85.8077C244.83 86.2391 243.772 86.4611 242.702 86.4595C241.597 86.4595 240.546 86.2268 239.596 85.8072Z",
    stroke: "#9FA3A6",
    style: (_ref99 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref99, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref99, "strokeOpacity", 1), _ref99),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.402 78.7605C250.402 83.0131 246.955 86.4605 242.702 86.4605C238.449 86.4605 235.002 83.0131 235.002 78.7605C235.002 74.5079 238.449 71.0605 242.702 71.0605C246.955 71.0605 250.402 74.5079 250.402 78.7605Z",
    stroke: "#9FA3A6",
    style: (_ref100 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref100, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref100, "strokeOpacity", 1), _ref100),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.596 85.8086C236.794 86.644 234.603 88.5784 233.745 91.0006C233.28 92.3151 234.244 93.5509 235.625 93.7473C237.108 93.9574 239.394 94.1609 242.702 94.1609C246.01 94.1609 248.296 93.9574 249.779 93.7473C251.16 93.5509 252.125 92.3151 251.659 91.0006C250.801 88.5784 248.61 86.644 245.808 85.8086",
    stroke: "#9FA3A6",
    style: (_ref101 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref101, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref101, "strokeOpacity", 1), _ref101),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.402 78.7605C246.149 78.7605 242.702 75.3131 242.702 71.0605C242.702 75.3131 239.255 78.7605 235.002 78.7605",
    stroke: "#9FA3A6",
    style: (_ref102 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref102, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref102, "strokeOpacity", 1), _ref102),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.902 82.3359C243.939 83.8028 241.464 83.8028 240.502 82.3359",
    stroke: "#9FA3A6",
    style: (_ref103 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref103, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref103, "strokeOpacity", 1), _ref103),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.951 79.3105V79.5855",
    stroke: "#9FA3A6",
    style: (_ref104 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref104, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref104, "strokeOpacity", 1), _ref104),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.451 79.3105V79.5855",
    stroke: "#9FA3A6",
    style: (_ref105 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref105, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref105, "strokeOpacity", 1), _ref105),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.5,
    y: 35.4102,
    width: 65.627,
    height: 65.627,
    rx: 18,
    fill: "#F3F3F4",
    style: (_ref106 = {
      fill: "#F3F3F4"
    }, _defineProperty(_ref106, "fill", "color(display-p3 0.9529 0.9529 0.9569)"), _defineProperty(_ref106, "fillOpacity", 1), _ref106)
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_27344_71754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.7207 80.834H87.9241",
    stroke: "#101820",
    style: (_ref107 = {
      stroke: "#101820"
    }, _defineProperty(_ref107, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref107, "strokeOpacity", 1), _ref107),
    strokeWidth: 2.06904,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8223 78.7324V82.9358",
    stroke: "#101820",
    style: (_ref108 = {
      stroke: "#101820"
    }, _defineProperty(_ref108, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref108, "strokeOpacity", 1), _ref108),
    strokeWidth: 2.06904,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5508 58.7637H65.8558",
    stroke: "#101820",
    style: (_ref109 = {
      stroke: "#101820"
    }, _defineProperty(_ref109, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref109, "strokeOpacity", 1), _ref109),
    strokeWidth: 2.06904,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7031 55.6133V61.9183",
    stroke: "#101820",
    style: (_ref110 = {
      stroke: "#101820"
    }, _defineProperty(_ref110, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref110, "strokeOpacity", 1), _ref110),
    strokeWidth: 2.06904,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4395 61.6538C78.4395 62.5679 78.8026 63.4446 79.449 64.091C80.0954 64.7374 80.9721 65.1006 81.8862 65.1006C82.8004 65.1006 83.6771 64.7374 84.3234 64.091C84.9698 63.4446 85.333 62.5679 85.333 61.6538C85.333 60.7397 84.9698 59.863 84.3234 59.2166C83.6771 58.5702 82.8004 58.207 81.8862 58.207C80.9721 58.207 80.0954 58.5702 79.449 59.2166C78.8026 59.863 78.4395 60.7397 78.4395 61.6538Z",
    stroke: "#101820",
    style: (_ref111 = {
      stroke: "#101820"
    }, _defineProperty(_ref111, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref111, "strokeOpacity", 1), _ref111),
    strokeWidth: 2.06904,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7108 65.7635L60.4001 79.0742C59.8613 79.613 59.5586 80.3438 59.5586 81.1058C59.5586 81.8678 59.8613 82.5986 60.4001 83.1375C60.9389 83.6763 61.6697 83.979 62.4318 83.979C63.1938 83.979 63.9246 83.6763 64.4634 83.1375L66.488 81.1114L68.5308 83.1543C68.9619 83.5853 69.5465 83.8275 70.1561 83.8275C70.7657 83.8275 71.3504 83.5853 71.7814 83.1543C72.2125 82.7232 72.4547 82.1386 72.4547 81.529C72.4547 80.9194 72.2125 80.3347 71.7814 79.9037L69.74 77.8608L77.774 69.8268C79.7254 70.8119 81.9639 71.0695 84.0879 70.5533C86.212 70.0371 88.0826 68.7809 89.3642 67.0101C90.6457 65.2393 91.2543 63.0698 91.0808 60.8908C90.9073 58.7118 89.963 56.6659 88.4173 55.1202C86.8717 53.5746 84.8258 52.6303 82.6468 52.4568C80.4678 52.2832 78.2983 52.8918 76.5275 54.1734C74.7567 55.4549 73.5005 57.3256 72.9843 59.4496C72.4681 61.5737 72.7257 63.8122 73.7108 65.7635Z",
    stroke: "#101820",
    style: (_ref112 = {
      stroke: "#101820"
    }, _defineProperty(_ref112, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref112, "strokeOpacity", 1), _ref112),
    strokeWidth: 2.06904,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_27344_71754)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 173.5,
    y: -18.5898,
    width: 46.4,
    height: 46.4,
    rx: 23.2,
    fill: "#F3F3F4",
    style: (_ref113 = {
      fill: "#F3F3F4"
    }, _defineProperty(_ref113, "fill", "color(display-p3 0.9529 0.9529 0.9569)"), _defineProperty(_ref113, "fillOpacity", 1), _ref113)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.002 0.760547C189.002 5.01315 192.449 8.46055 196.702 8.46055C200.955 8.46055 204.402 5.01315 204.402 0.760547C204.402 -3.49205 200.955 -6.93945 196.702 -6.93945C192.449 -6.93945 189.002 -3.49205 189.002 0.760547Z",
    stroke: "#9FA3A6",
    style: (_ref114 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref114, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref114, "strokeOpacity", 1), _ref114),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.002 0.760547C193.028 0.741297 196.33 -2.63185 196.702 -6.93945C192.676 -6.9202 189.374 -3.54705 189.002 0.760547Z",
    stroke: "#9FA3A6",
    style: (_ref115 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref115, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref115, "strokeOpacity", 1), _ref115),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.401 0.760547C200.375 0.741297 197.073 -2.63185 196.701 -6.93945C200.727 -6.9202 204.029 -3.54705 204.401 0.760547Z",
    stroke: "#9FA3A6",
    style: (_ref116 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref116, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref116, "strokeOpacity", 1), _ref116),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.596 7.80719C190.794 8.64319 188.603 10.5775 187.745 12.9997C187.28 14.3142 188.244 15.5501 189.625 15.7459C191.108 15.9571 193.395 16.16 196.702 16.16C200.009 16.16 202.296 15.9565 203.779 15.7459C205.16 15.5501 206.125 14.3142 205.659 12.9997C204.801 10.5775 202.61 8.64319 199.808 7.80774C198.83 8.23912 197.772 8.46112 196.702 8.45949C195.597 8.45949 194.546 8.22684 193.596 7.80719Z",
    stroke: "#9FA3A6",
    style: (_ref117 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref117, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref117, "strokeOpacity", 1), _ref117),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.402 0.760547C204.402 5.01315 200.955 8.46055 196.702 8.46055C192.449 8.46055 189.002 5.01315 189.002 0.760547C189.002 -3.49205 192.449 -6.93945 196.702 -6.93945C200.955 -6.93945 204.402 -3.49205 204.402 0.760547Z",
    stroke: "#9FA3A6",
    style: (_ref118 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref118, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref118, "strokeOpacity", 1), _ref118),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.596 7.80859C190.794 8.64404 188.603 10.5784 187.745 13.0006C187.28 14.3151 188.244 15.5509 189.625 15.7473C191.108 15.9574 193.394 16.1609 196.702 16.1609C200.01 16.1609 202.296 15.9574 203.779 15.7473C205.16 15.5509 206.125 14.3151 205.659 13.0006C204.801 10.5784 202.61 8.64404 199.808 7.80859",
    stroke: "#9FA3A6",
    style: (_ref119 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref119, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref119, "strokeOpacity", 1), _ref119),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.402 0.760547C200.149 0.760547 196.702 -2.68685 196.702 -6.93945C196.702 -2.68685 193.255 0.760547 189.002 0.760547",
    stroke: "#9FA3A6",
    style: (_ref120 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref120, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref120, "strokeOpacity", 1), _ref120),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.902 4.33594C197.939 5.80279 195.464 5.80279 194.502 4.33594",
    stroke: "#9FA3A6",
    style: (_ref121 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref121, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref121, "strokeOpacity", 1), _ref121),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.951 1.31055V1.58555",
    stroke: "#9FA3A6",
    style: (_ref122 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref122, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref122, "strokeOpacity", 1), _ref122),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.451 1.31055V1.58555",
    stroke: "#9FA3A6",
    style: (_ref123 = {
      stroke: "#9FA3A6"
    }, _defineProperty(_ref123, "stroke", "color(display-p3 0.6235 0.6392 0.6510)"), _defineProperty(_ref123, "strokeOpacity", 1), _ref123),
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_dd_27344_71754)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.5,
    y: 27.4102,
    width: 25.2727,
    height: 25.2727,
    rx: 12.6364,
    fill: "#52EAAF",
    style: (_ref124 = {
      fill: "#52EAAF"
    }, _defineProperty(_ref124, "fill", "color(display-p3 0.3216 0.9176 0.6863)"), _defineProperty(_ref124, "fillOpacity", 1), _ref124),
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_27344_71754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.7891 39.1765V37.7469C99.7891 36.6265 100.716 35.6992 101.798 35.6992C102.88 35.6992 103.807 36.6265 103.807 37.7469V39.1765",
    stroke: "#101820",
    style: (_ref125 = {
      stroke: "#101820"
    }, _defineProperty(_ref125, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref125, "strokeOpacity", 1), _ref125),
    strokeWidth: 0.579545,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.482 43.8141C108.482 44.1232 108.212 44.3936 107.903 44.3936H102.687C102.378 44.3936 102.107 44.1232 102.107 43.8141V39.7573C102.107 39.4482 102.378 39.1777 102.687 39.1777H107.903C108.212 39.1777 108.482 39.4482 108.482 39.7573V43.8141Z",
    stroke: "#101820",
    style: (_ref126 = {
      stroke: "#101820"
    }, _defineProperty(_ref126, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref126, "strokeOpacity", 1), _ref126),
    strokeWidth: 0.579545,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.75 41.3981C103.643 41.3981 103.557 41.3116 103.557 41.2049C103.557 41.0982 103.643 41.0117 103.75 41.0117",
    stroke: "#101820",
    style: (_ref127 = {
      stroke: "#101820"
    }, _defineProperty(_ref127, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref127, "strokeOpacity", 1), _ref127),
    strokeWidth: 0.579545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.75 41.3981C103.857 41.3981 103.943 41.3116 103.943 41.2049C103.943 41.0982 103.857 41.0117 103.75 41.0117",
    stroke: "#101820",
    style: (_ref128 = {
      stroke: "#101820"
    }, _defineProperty(_ref128, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref128, "strokeOpacity", 1), _ref128),
    strokeWidth: 0.579545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.842 41.3981C106.735 41.3981 106.648 41.3116 106.648 41.2049C106.648 41.0982 106.735 41.0117 106.842 41.0117",
    stroke: "#101820",
    style: (_ref129 = {
      stroke: "#101820"
    }, _defineProperty(_ref129, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref129, "strokeOpacity", 1), _ref129),
    strokeWidth: 0.579545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.842 41.3981C106.948 41.3981 107.035 41.3116 107.035 41.2049C107.035 41.0982 106.948 41.0117 106.842 41.0117",
    stroke: "#101820",
    style: (_ref130 = {
      stroke: "#101820"
    }, _defineProperty(_ref130, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref130, "strokeOpacity", 1), _ref130),
    strokeWidth: 0.579545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.33 42.3652C104.394 42.5584 104.678 42.9448 105.296 42.9448C105.914 42.9448 106.197 42.5584 106.262 42.3652",
    stroke: "#101820",
    style: (_ref131 = {
      stroke: "#101820"
    }, _defineProperty(_ref131, "stroke", "color(display-p3 0.0627 0.0941 0.1255)"), _defineProperty(_ref131, "strokeOpacity", 1), _ref131),
    strokeWidth: 0.579545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_27344_71754",
    x: -0.5,
    y: -1,
    width: 628,
    height: 122,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_27344_71754"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_27344_71754",
    result: "shape"
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_27344_71754",
    x: 370.348,
    y: 16.9708,
    width: 99.5408,
    height: 92.5916,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.07612
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.495833 0 0 0 0 1 0 0 0 0 0.803641 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27344_71754"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.02537
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_27344_71754",
    result: "effect2_dropShadow_27344_71754"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_27344_71754",
    result: "shape"
  }))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_27344_71754",
    x: 467.254,
    y: 49.7207,
    width: 187.492,
    height: 10.8788,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.36716
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.495833 0 0 0 0 1 0 0 0 0 0.803641 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27344_71754"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.455721
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_27344_71754",
    result: "effect2_dropShadow_27344_71754"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_27344_71754",
    result: "shape"
  }))), _filter4 || (_filter4 = /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dd_27344_71754",
    x: 111.938,
    y: 14.8731,
    width: 261.42,
    height: 47.5429,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.36716
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.495833 0 0 0 0 1 0 0 0 0 0.803641 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27344_71754"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.455721
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_27344_71754",
    result: "effect2_dropShadow_27344_71754"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_27344_71754",
    result: "shape"
  }))), _filter5 || (_filter5 = /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_27344_71754",
    x: 331.5,
    y: 85.4102,
    width: 54.4004,
    height: 54.4004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_27344_71754"
  }))), _filter6 || (_filter6 = /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_27344_71754",
    x: 517.086,
    y: -53.0036,
    width: 100.828,
    height: 100.828,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.7069,
    result: "effect1_foregroundBlur_27344_71754"
  }))), _filter7 || (_filter7 = /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_27344_71754",
    x: 339.557,
    y: -12.5331,
    width: 53.287,
    height: 53.287,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.17184,
    result: "effect1_foregroundBlur_27344_71754"
  }))), _filter8 || (_filter8 = /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_27344_71754",
    x: 169.5,
    y: -22.5898,
    width: 54.4004,
    height: 54.4004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_27344_71754"
  }))), _filter9 || (_filter9 = /*#__PURE__*/React.createElement("filter", {
    id: "filter8_dd_27344_71754",
    x: 89.123,
    y: 25.0332,
    width: 30.0274,
    height: 30.0274,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.1885
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.495833 0 0 0 0 1 0 0 0 0 0.803641 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27344_71754"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.396167
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_27344_71754",
    result: "effect2_dropShadow_27344_71754"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_27344_71754",
    result: "shape"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_27344_71754",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(313.5 60) rotate(90.3212) scale(62.6592 312.998)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.692708,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901042,
    stopColor: "#F9F9F9",
    stopOpacity: 0.4,
    style: (_ref132 = {
      stopColor: "#F9F9F9"
    }, _defineProperty(_ref132, "stopColor", "color(display-p3 0.9764 0.9764 0.9764)"), _defineProperty(_ref132, "stopOpacity", 0.4), _ref132)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3F3",
    stopOpacity: 0.5,
    style: (_ref133 = {
      stopColor: "#F3F3F3"
    }, _defineProperty(_ref133, "stopColor", "color(display-p3 0.9514 0.9514 0.9514)"), _defineProperty(_ref133, "stopOpacity", 0.5), _ref133)
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27344_71754"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 626,
    height: 120,
    rx: 12,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_27344_71754"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.9184,
    height: 11.9185,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(414.174 80.6973)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_27344_71754"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.9184,
    height: 11.9184,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(386.033 50.9023)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_27344_71754"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.9184,
    height: 11.9184,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(442.314 50.9023)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_27344_71754"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.9184,
    height: 11.9184,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(414.174 25.2441)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_27344_71754"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.627,
    height: 33.627,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(58.5 51.4102)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_27344_71754"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.27273,
    height: 9.27273,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(99.5 35.4102)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPotentialAnalysisModal);
export default __webpack_public_path__ + "static/media/potential-analysis-modal.95b9d79c9bf2c5a09e5b0a6d0dfb7938.svg";
export { ForwardRef as ReactComponent };